export default "__VITE_ASSET__DIu9g591__"